export default function getTheme({ darkState }) {
  return {
    palette: {
      type: darkState ? "dark" : "light",
      primary: {
        main: darkState ? "#2196f3" : "#2196f3",
        dark: "#1E88E5",
      },
      secondary: {
        main: "rgb(220, 0, 78)",
      },
      background: {
        default: darkState ? "#303030" : "#edefef",
        paper: darkState ? "#424242" : "#f2f3f6", //f2f3f6
        toolbar: darkState ? "#424242" : "#f4f6f7", //f9f5f2, app.darkState ? "#424242" : "#f4f6f7";
        search: darkState ? "#424242" : "#f1f3f4", //f2f3f6
      },
      items: {
        survey: "#3f89ab", //2196f3
        esm: "#009688",
        protocol: "#9f8cae",
        moodboard: "#009688",
        button: "#00a0b2",
        app: "#d1701b",
        note: "#8d5ab5",
        date: "#9e9e9e",
      },
      text: {
        //primary: darkState ? "#fff" : "#222e54",
        //secondary: darkState ? "rgba(255, 255, 255, 0.7)" : "#7b89b6"
        survey: "#D9EDF8",
        esm: "#E0F2F1",
        date: "#fff",
      },
    },
    button: {
      textTransform: "lowercase",
    },
    typography: {
      button: {
        textTransform: "none",
      },
    },
    shape: {
      borderRadius: 6,
    },
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: false, // No more ripple, on the whole application 💣!
      },
    },
  };
}
